class PredictiveSearch extends HTMLElement {
  constructor () {
    super()
    this.cachedResults = {}
    this.input = this.querySelector('[data-predictive-search-el="input"]')
    this.modal = document.querySelector('[data-predictive-search-el="modal"]')
    this.animatedSearch = this.querySelector('[data-predictive-search-el="animated-search"]')
    this.overlay = document.querySelector('[data-predictive-search-el="overlay"]')
    this.noTermUi = this.querySelector('[data-predictive-search-el="no-term-ui"]')
    this.predictiveSearchResults = this.querySelector('[data-predictive-search-el="results"]')
    this.isOpen = false
    this.clearButton = this.querySelector('.clear__button')

    if (this.input.value.trim()) this.clearButton.style.display = 'block'

    this.setupEventListeners()
  }

  setHeaderHeightProperty () {
    const announcementBarEl = document.getElementById('shopify-section-fostr-announcement-bar')
    const announcementBarHeight = announcementBarEl ? announcementBarEl.scrollHeight : 0
    const announcementBarFixed = getComputedStyle(announcementBarEl).position === 'fixed' || false
    const announcementBarVisible = announcementBarFixed ? true : window.scrollY <= announcementBarHeight
    const announcementBarVisibleHeight = announcementBarFixed ? announcementBarHeight : announcementBarHeight - window.scrollY

    const headerEl = document.querySelector('.header.site-header')
    const headerHeight = headerEl.offsetHeight

    const heightValue = announcementBarVisible ? announcementBarVisibleHeight + headerHeight : headerHeight
    this.modal.style.setProperty('--HeaderHeight', `${heightValue}px`)
  }

  display () {
    this.setHeaderHeightProperty()
    this.modal.classList.add('open')
    document.body.classList.add('search-modal-open')
    this.renderRecentSearches()

    window.BAO.Utils.pushToDataLayer('search_open')

    setTimeout(() => {
      this.input.focus()
    }, 500)
  }

  hide () {
    this.modal.classList.remove('open')
    document.body.classList.remove('search-modal-open')
  }

  setupEventListeners () {
    const openButtons = document.querySelectorAll('[data-predictive-search-el="open"]')
    openButtons.forEach(button => {
      button.addEventListener('click', this.display.bind(this))
    })

    const closeButton = document.querySelector('[data-predictive-search-el="close"]')
    closeButton.addEventListener('click', this.hide.bind(this))
    this.overlay.addEventListener('click', this.hide.bind(this))

    const form = this.querySelector('form.search')
    form.addEventListener('submit', this.onFormSubmit.bind(this))

    this.input.addEventListener('input', this.onChange.bind(this))

    this.input.addEventListener('focus', this.onFocus.bind(this))
    this.addEventListener('keyup', this.onKeyup.bind(this))
    this.addEventListener('keydown', this.onKeydown.bind(this))

    this.clearButton.addEventListener('click', this.clearInput.bind(this))
  }

  getQuery () {
    return this.input.value.trim()
  }

  onChange () {
    const searchTerm = this.getQuery()
    this.animatedSearch?.setAttribute('aria-hidden', searchTerm.length > 0)
    this.predictiveSearchResults.setAttribute('aria-hidden', searchTerm.length === 0)

    if (!searchTerm.length) {
      this.hideResults(true)
      this.clearButton.style.display = 'none';
      return;
    }

    this.clearButton.style.display = 'block';
    this.getSearchResults(searchTerm)
  }

  onFormSubmit (event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) {
      event.preventDefault()
    } else {
      this.cacheRecentSearches()
    }
  }

  onFocus () {
    const searchTerm = this.getQuery()
    this.animatedSearch?.setAttribute('aria-hidden', searchTerm.length > 0)
    this.predictiveSearchResults.setAttribute('aria-hidden', searchTerm.length === 0)

    if (!searchTerm.length) return

    if (this.getAttribute('results') === 'true') {
      this.showResults()
    } else {
      this.getSearchResults(searchTerm)
    }
  }

  onKeyup (event) {
    if (!this.getQuery().length) this.hideResults(true)
    event.preventDefault()

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up')
        break
      case 'ArrowDown':
        this.switchOption('down')
        break
      case 'Enter':
        this.selectOption()
        break
    }
  }

  onKeydown (event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (
      event.code === 'ArrowUp' ||
      event.code === 'ArrowDown'
    ) {
      event.preventDefault()
    }
  }

  cacheRecentSearches () {
    let recentSearches = localStorage.getItem('recentSearches')
    const query = this.getQuery()

    recentSearches = recentSearches ? [...recentSearches.split(','), query] : [query]
    recentSearches = recentSearches.length > 6 ? recentSearches.slice(1) : recentSearches

    localStorage.setItem('recentSearches', recentSearches.toString())
  }

  renderRecentSearches () {
    const recentSearchesListEls = document.querySelectorAll('[data-predictive-search-el="recent-search-list"]')
    const recentSearches = localStorage.getItem('recentSearches')
    const recentSearchPanel = document.querySelector('[data-predictive-search-el="recent-searches-panel"]')

    if (!recentSearchesListEls.length || !recentSearches) {
      recentSearchPanel.style.display = 'none'
    } else {
      recentSearchPanel.style.display = 'block'
      const recentSearchesArr = recentSearches.split(',')

      let recentSearchItemsHTML = ''

      recentSearchesArr.forEach(query => {
        recentSearchItemsHTML += this.recentSearchItemHTML(query)
      })

      recentSearchesListEls.forEach(el => el.innerHTML = recentSearchItemsHTML)

      const recentSearchesPanelEl = document.querySelector('[data-predictive-search-el="recent-searches-panel"]')
      const recentSearchesTabEl = document.querySelector('[data-predictive-search-el="recent-searches-tab"]')

      recentSearchesPanelEl.setAttribute('data-panel-has-content', 'true')
      recentSearchesTabEl.setAttribute('data-panel-has-content', 'true')
    }
  }

  recentSearchItemHTML (query) {
    return `
      <li class="predictive-search__sidebar-list-item">
        <a class="predictive-search__sidebar-link" href="/search?q=${query}">${query}</a>
      </li>
    `
  }

  switchOption (direction) {
    if (!this.getAttribute('open')) return

    const moveUp = direction === 'up'
    const selectedElement = this.querySelector('[aria-selected="true"]')
    const allElements = this.querySelectorAll('li')
    let activeElement = this.querySelector('li')

    if (moveUp && !selectedElement) return

    this.statusElement.textContent = ''

    if (!moveUp && selectedElement) {
      activeElement = selectedElement.nextElementSibling || allElements[0]
    } else if (moveUp) {
      activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1]
    }

    if (activeElement === selectedElement) return

    activeElement.setAttribute('aria-selected', true)
    if (selectedElement) selectedElement.setAttribute('aria-selected', false)

    this.setLiveRegionText(activeElement.textContent)
    this.input.setAttribute('aria-activedescendant', activeElement.id)
  }

  selectOption () {
    const selectedProduct = this.querySelector('[aria-selected="true"] a, [aria-selected="true"] button')

    if (selectedProduct) selectedProduct.click()
  }

  getSearchResults (searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase()
    this.setLiveRegionLoadingState()

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey])
      return
    }

    const requestUrl = `${routes.predictive_search_url}?q=${searchTerm}&resources[type]=product,collection,query&resources[limit]=10&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,tag&section_id=predictive-search`

    fetch(requestUrl)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.hideResults()
          throw error
        }
        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML
        this.cachedResults[queryKey] = resultsMarkup
        this.renderSearchResults(resultsMarkup)
      })
      .catch((error) => {
        this.hideResults()
        throw error
      })
  }

  setLiveRegionLoadingState () {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status')
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text')

    this.setLiveRegionText(this.loadingText)
    this.setAttribute('loading', true)
  }

  setLiveRegionText (statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false')
    this.statusElement.textContent = statusText

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true')
    }, 1000)
  }

  renderSearchResults (resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup
    this.setAttribute('results', true)

    this.setLiveRegionResults()
    this.showResults()
    this.populateProductCount()
  }

  populateProductCount () {
    const searchTerm = this.getQuery()
    fetch(`/search?sections=search-results-count&q=${searchTerm}`)
      .then(response => response.text())
      .then(data => {
        const htmlString = data.replaceAll('\\', '')
        const resultCount = new DOMParser().parseFromString(htmlString, 'text/html').querySelector('#shopify-section-search-results-count').textContent
        const targetSpan = this.querySelector('.populate-product-count')
        if (targetSpan) {
          targetSpan.textContent = `(${resultCount})`
        } else {
          setTimeout(() => {
            const targetSpan = this.querySelector('.populate-product-count')
            if (targetSpan) targetSpan.textContent = `(${resultCount})`
          }, 100)
        }
      })
  }

  setLiveRegionResults () {
    this.removeAttribute('loading')
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent)
  }

  getResultsMaxHeight () {
    this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom
    return this.resultsMaxHeight
  }

  showResults () {
    this.noTermUi.setAttribute('aria-hidden', 'true')

    if (this.overlay) {
      this.overlay.classList.add('show-on-mobile')
    }

    this.setAttribute('open', true)
    this.input.setAttribute('aria-expanded', true)
    this.isOpen = true
  }

  hideResults (clearSearchTerm = false) {
    this.noTermUi.setAttribute('aria-hidden', 'false')

    if (this.overlay) {
      this.overlay.classList.remove('show-on-mobile')
    }

    if (clearSearchTerm) {
      this.input.value = ''
      this.removeAttribute('results')
    }

    this.input.setAttribute('aria-activedescendant', '')
    this.removeAttribute('open')
    this.input.setAttribute('aria-expanded', false)
    this.resultsMaxHeight = false
    this.predictiveSearchResults.removeAttribute('style')

    this.isOpen = false
  }

  clearInput () {
    event.preventDefault()
    this.clearButton.style.display = 'none'
    this.input.value = ''
    this.hideResults()
    this.input.focus()
  }
}

customElements.define('predictive-search', PredictiveSearch)
